<template>
  <div class="moduleTutorialWrap">
    <div class="content">
      <p class="title">{{ $t('lang.k_043001') }}</p>
      <div class="content-container">
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">
            {{ $t('lang.k_043002') }}
          </p>
        </article>
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">
            <strong>{{ $t('lang.k_043003') }}</strong>
            <br />
            {{ $t('lang.k_043004') }}
            <br />
            {{ $t('lang.k_043005') }}
            <br />
            {{ $t('lang.k_043006') }}
            <br />
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="less" scoped>
  .moduleTutorialWrap {
    background-image: url('../../common/images/subtitle_intro.png');
    background-size: cover;
    height: 500px;
  }
  .content {
    padding: 130px 0 0 464px;
    height: 100%;
    position: relative;
    pointer-events: none;

    .content-container {
      position: absolute;
      top: 170px;
      width: 300px;
      bottom: 20px;
      overflow: auto;
      pointer-events: initial;
    }
    .title {
      min-width: 95px;
      display: inline-block;
      padding: 0 10px;
      height: 24px;
      background: #fb3d32;
      border-radius: 12px;
      color: #ffffff;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
    }
    .valueItem {
      .itemTitle {
        width: 33px;
        height: 3px;
        margin-top: 22px;
        // background-image: linear-gradient(to right, color-stop1, color-stop2);
        background: linear-gradient(270deg, rgba(255, 255, 255, 0.2) 0%, #fb3b32 100%);
      }
      .itemValue {
        width: 280px;
        padding-top: 10px;
        font-size: 14px;
        font-weight: 0;
        color: #000000;
        line-height: 20px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        strong {
          font-weight: 900;
        }
      }
    }
  }
</style>
